<template>
  <div class="parking-orderDetails">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="120">
      <template #btn>
        <auth-button auth="market:parking:order:download" class="el-button el-button--default">
          <el-button  @click="onExport" :loading="exportLoading">导出</el-button>
        </auth-button>
      </template>
    </Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #billId="{ row }">
        <el-button class="look-billId-btn"  type="text" @click="lookDetaile(row)">
          {{row.billId}}
        </el-button>
      </template>
      <template #orderNo="{ row }">{{ row.orderNo||'---' }}</template>
      <template #name="{ row }">{{ row.name ||'---'  }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey" v-if="row.phone">{{ row.phone_show || row.phone }}</span>
        <span v-else>---</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #thirdOrderNo="{ row }">{{ row.thirdOrderNo ||'---'  }}</template>
      <template #amount="{ row }">{{ row.amount||'---'  }}</template>
      <template #actualAmount="{ row }">{{ row.actualAmount ||'---' }}</template>
      <template #plateNumber="{ row }">{{ row.plateNumber||'---'  }}</template>
      <template #status="{ row }">{{ row.status||'---'  }}</template>
      <template #payTime="{ row }">{{ row.payTime||'---' }}</template>
      <template #discounts="{ row }">
          <div v-if="row.discounts&&row.discounts.length!=0">
            <div v-for="(item, index) in row.discounts" :key="index">{{`${item.name}抵扣${item.discount }`}}</div>
          </div>
          <div v-else>---</div>
      </template>
    </Table>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import { api_getParkingOrderDetailsPage, api_getParkingOrderDetailsExport} from '@/api/parking'
import { api_getUserPhone } from '@/api/common'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
export default {
  name: "orderDetails",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    const startDate = this.$moment().subtract(7, 'days').valueOf() //默认开始时间
    const endDate = this.$moment().subtract(0, 'days').valueOf() //默认结束时间
    return {
      exportLoading:false,
      tableKey: false,
      renderData: [
        {
          label: "支付时间",
          placeholder: ['起始时间', '截止时间'],
          type: "date-range",
          key: "payTime",
          valueFormat: 'timestamp'
        },
        {
          label: "账单ID",
          placeholder: "请输入账单ID",
          type: "input",
          key: "billId",
          isNumber:true
        },
        {
          label: "停车场名称",
          placeholder: "请输入停车场名称",
          type: "input",
          key: "name",
          isNumber:true
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
          maxLength:'11'
        },
        {
          label: "交易流水号",
          placeholder: "请输入交易流水号",
          type: "input",
          key: "orderNo",
        },
        {
          label: "车场订单号",
          placeholder: "请输入车场订单号",
          type: "input",
          key: "thirdOrderNo",
        },
        {
          label: "车牌号",
          placeholder: "请输入车牌号",
          type: "input",
          key: "plateNumber",
        },
        {
          label: "订单状态",
          placeholder: "请选择订单状态",
          type: "select",
          multiple: false,
          key: "status",
          option: [{
            label: '支付成功',
            value: 'PaymentSuccess'
          },{
            label: '已取消',
            value: 'Canceled'
          }],
        },
      ],
      form: {
        payTime:[startDate,endDate]
      },
      tableTrData:[],
      tableThData: [
        { prop: "billId", label: "账单ID", minWidth: "100", },
        { prop: "name", label: "停车场", minWidth: "200", },
        { prop: "phone", label: "会员手机号", minWidth: "130", },
        { prop: "orderNo", label: "交易流水号", minWidth: "170", },
        { prop: "thirdOrderNo", label: "车场订单号", minWidth: "170", },
        { prop: "plateNumber", label: "车牌号", minWidth: "170", },
        { prop: "amount", label: "应付金额", minWidth: "170", },
        { prop: "actualAmount", label: "实付金额", minWidth: "170", },
        { prop: "discounts", label: "优惠信息", minWidth: "200", },
        { prop: "status", label: "订单状态", minWidth: "150", },
        { prop: "payTime", label: "支付时间", minWidth: "170", },
      ],
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.payTimeFrom = this.form.payTime ? this.form.payTime[0] : this.$moment().subtract(7, 'days').valueOf()
      params.payTimeTo = this.form.payTime ? this.form.payTime[1] : this.$moment().subtract(0, 'days').valueOf()
      delete params.payTime
      const data = await api_getParkingOrderDetailsPage(params)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    lookDetaile (row) {
      this.$router.push({
        path: `/parkMangement/paymentRecord/detail?id=${row.billId}`
      })
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableTrData[index].phone_show
        this.tableKey = !this.tableKey
      } catch (error) {
            console.log(error)
      }
    },
    //导出
     async onExport() {
      this.exportLoading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      params = {
        ...params,
      }
      params.payTimeFrom = this.form.payTime ? params.payTime[0] : this.$moment().subtract(7, 'days').valueOf(),
      params.payTimeTo = this.form.payTime ? params.payTime[1] : this.$moment().subtract(0, 'days').valueOf()
      params.billId == '' ? delete params.billId:''
      params.phone == '' ? delete params.phone:''
      params.orderNo == ''? delete params.orderNo:''
      params.thirdOrderNo == ''? delete params.thirdOrderNo:''
      params.plateNumber == ''? delete params.plateNumber:''
      params.status == ''? delete params.status:''
      delete params.payTime
      let res = await api_getParkingOrderDetailsExport(params)
      console.log(res)
      downFile(res)
      this.exportLoading = false
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.parking-orderDetails {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  ::v-deep{
    .search-box{
      margin-top: 20px;
    }
  }
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }
  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
    background: #dcdfe6;
  }
  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
    border-radius: 10px;
    background: #fafafa;
  }
  /deep/ .exportBtn{
    margin-left: 20rp !important;
  }
  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }
  .look-billId-btn{
    font-size: 12px;
    color: #3775FF;
    margin-left: 5px;
  }
  ::v-deep{
    .el-table__body-wrapper::-webkit-scrollbar{
      /*滚动条整体样式*/
      width: 4px !important; /*高宽分别对应横竖滚动条的尺寸*/
      height: 5px !important;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
      background: #dcdfe6;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
      border-radius: 10px;
      background: #fafafa;
    }
    .el-table__fixed{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
    .el-table__fixed-right{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
  }
}
</style>
